/**
 * HowToJsonLd — emits HowTo JSON-LD schema for step-by-step tutorial pages.
 *
 * Used by the probe-driven irrigation methodology page to mark up its
 * 5-step formula. Google rewards HowTo schema with rich step carousels in
 * SERPs, and AI Search engines (Perplexity, ChatGPT) preferentially cite
 * structured tutorials.
 *
 * Usage:
 *   <HowToJsonLd
 *     name="How to translate a soil probe reading into runtime"
 *     description="The 5-step formula..."
 *     totalTime="PT5M"
 *     steps={[
 *       { name: 'Pick a target SVWC', text: 'For Bermuda, target 30%...' },
 *     ]}
 *   />
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const HowToJsonLd = ({ name, description, totalTime, steps, image }) => {
  if (!Array.isArray(steps) || steps.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name,
    description,
    ...(totalTime ? { totalTime } : {}),
    ...(image ? { image } : {}),
    step: steps.map((s, idx) => ({
      '@type': 'HowToStep',
      position: idx + 1,
      name: s.name,
      text: s.text,
      ...(s.image ? { image: s.image } : {}),
      ...(s.url ? { url: s.url } : {}),
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default HowToJsonLd;
